export default __webpack_public_path__ + "static/media/022.85a46aaa.jpg";